// extracted by mini-css-extract-plugin
export default {"modalBody":"modalBody-hB4pr","body":"body-PnIUt","description":"description-ssob4"};